interface SEOHeadProps {
  title: string;
  description: string;
  canonical?: string | undefined;
  ogImage?: string | undefined;
  noIndex?: boolean | undefined;
  schemaJson?: object | null | (object | null | undefined)[] | undefined;
}

/**
 * INERT.
 *
 * Head metadata (title, description, canonical, og:*, twitter:*, JSON-LD) is
 * now owned by each route's server-rendered `head()` — see src/lib/route-head.ts
 * and src/lib/route-seo.ts — so it appears in the SSR HTML for crawlers that
 * never run JavaScript.
 *
 * This component intentionally writes nothing. If it wrote the same tags on the
 * client it would duplicate the server-rendered head and cause hydration
 * mismatches. It stays only so existing page-level call sites keep compiling.
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const SEOHead = (_props: SEOHeadProps) => null;

export default SEOHead;
